<template>
    <span>
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col md="8" lg="9">
              <h3 tabindex="0">Salas de Chat</h3>
            </b-col>
            <b-col v-if="perfil.is_admin_conferencia" sm="12" md="4" lg="3">
              <b-button @click="navigate('/salachat/cadastrar')" block variant="primary">
                    <i class="fa fa-plus"></i>
                  <span>Nova Sala</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                  <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Nome da sala..."></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="perfil.is_admin_conferencia">
            <b-col sm="12" md="6" lg="6">
              <b-form-group label="Situação:">
                <b-form-select v-model="filtros.situacao" class="mb-3">
                    <option selected :value="null"> Selecione </option>
                    <option v-for="situacao in situacoes" :value="situacao.value" :key="situacao.value"> {{ situacao.text }} </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="4" lg="3">
              <b-button block variant="primary"  @click="pesquisar()">
                <i class="fa fa-search"></i>&nbsp;Pesquisar
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>

        <b-row>
          <b-col sm="12">
            <b-container fluid>
              <span>
                <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th tabindex="0" v-if="perfil.is_admin_conferencia" scope="col" style="width: 10%">Habilitar Sala</th>
                      <th tabindex="0" scope="col" style="width: 70%">Título</th>
                      <th tabindex="0" v-if="perfil.is_admin_conferencia" scope="col" style="width: 10%">Status</th>
                      <th tabindex="0" scope="col" style="width: 10%">Ações</th>
                    </tr>
                  </thead>

                  <tbody v-if="salas.data !== undefined">
                    <tr class="action" v-for="sala in salas.data" :key="sala.id">                     
                      <td v-if="perfil.is_admin_conferencia">
                        <label class="form-checkbox">
                          <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" :id="'defaultInline1' + sala.id" :value="sala.id" v-model="selecionados" :disabled="sala.situacao == 'E'" :checked="sala.situacao == 'E'">
                            <label class="custom-control-label" :for="'defaultInline1' + sala.id"></label>
                          </div>
                        </label>
                      </td>
                      <td tabindex="0">{{sala.titulo}}</td>
                      <td v-if="perfil.is_admin_conferencia">
                        <span tabindex="0" v-if="sala.situacao === 'C'" class="badge badge-primary">Salvo</span>
                        <span tabindex="0" v-if="sala.situacao === 'E'" class="badge badge-success">Enviado</span>
                        <span tabindex="0" v-if="sala.situacao === 'S'" class="badge badge-danger">Suspenso</span>
                      </td>
                      <td style="width: 15%">
                          <b-button tabindex="0" v-if="perfil.is_admin_conferencia && (sala.situacao === 'C' || sala.situacao === 'S')" class="btn btn-sm btn-secondary action" title="Editar" @click="editarSala(sala.id)">
                            <i class="fa fa-pencil-square-o"></i>
                          </b-button>

                          <b-button  tabindex="0" class="btn btn-sm btn-secondary action" title="Visualizar" @click="visualizarSala(sala.id)">
                            <i class="fa fa-search"></i>
                          </b-button>

                          <b-button tabindex="0" v-if="perfil.is_admin_conferencia && (sala.situacao === 'C' || sala.situacao === 'S')" class="btn btn-sm btn-secondary action" title="Enviar Sala" @click="enviarSala(sala.id)">
                            <i class="fa fa-envelope"></i>
                          </b-button>

                          <b-button tabindex="0" v-if="sala.situacao === 'E' && perfil.is_admin_conferencia" class="btn btn-sm btn-secondary action" title="Suspender" @click="suspenderSala(sala.id)">
                            <i class="fa fa-times"></i>
                          </b-button>

                          <b-button tabindex="0" class="btn btn-sm btn-secondary action" v-if="perfil.is_admin_conferencia" title="Exportar" @click="exportarSala(sala.id)">
                            <i class="fa fa-file"></i>
                          </b-button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td colspan="4" tabindex="0">Nenhuma sala cadastrada</td>
                    </tr>
                  </tbody>
                </table>
                <pagination tabindex="0" v-show="salas.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource" :filtros="filtros"></pagination>
              </span>
            </b-container>
          </b-col>
        </b-row>
        <b-card-footer v-if="perfil.is_admin_conferencia" class="p-12">
          <b-row>
            <b-col md="4" offset-md="8" offset-lg="9" lg="3">
              <b-button block variant="primary" tabindex="0" @click="enviarSalas()">
                <i class="fa fa-envelope"></i>&nbsp;&nbsp;<span>Enviar Salas</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import {DatePicker, setupCalendar} from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  name: 'SalaChat',
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  created () {
    if (!this.can('salachat.index')) {
      // this.$router.push('/')
    }
  },
  beforeUpdate () {
    if (this.$store.state.perfil.perfil.is_participante) {
      this.filtros.situacao = 'E'
    }
  },
  data () {
    return {
      totalPorPagina: 30,
      resource: 'salachat',
      filtros: {
        filter: null,
        situacao: 'E'
      },
      situacoes: [
        {'value': 'C', 'text': 'Salvo'},
        {'value': 'E', 'text': 'Enviado'},
        {'value': 'S', 'text': 'Suspenso'}
      ],
      selecionados: []
    }
  },
  computed: {
    salas () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    inputState () {
      if (!this.selectedValue) {
        return {
          type: 'is-danger',
          message: 'Data do cadastro'
        }
      }
      return {
        type: 'is-primary',
        message: ''
      }
    },
    perfil () {
      return this.$store.state.perfil.perfil  
    }
  },
  methods: {
    can (permissao) {
      // return this.$store.getters.validaPermissao(permissao)
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar () { 
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    editarSala (id) {
      this.$router.push('/salachat/editar/' + id)
    },
    visualizarSala (id) {
      this.$router.push('/salachat/visualizar/' + id)
    },
    enviarSala (id) {
      let data = []
      data.push(id)
      this.$bvModal.msgBoxConfirm('Deseja publicar essa sala de chat? Ao publicar, estará permitindo aos participantes a visualização e/ou inserção de comentários.', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/salachat/enviado/publicacao', data).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    enviarSalas () {
      this.$bvModal.msgBoxConfirm('Deseja publicar essa sala de chat? Ao publicar, estará permitindo aos participantes a visualização e/ou inserção de comentários.', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.put('api/salachat/enviado/publicacao', this.selecionados).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.selecionados = []
            this.loading = false
          }).catch(e => {
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    suspenderSala (id) {
      this.$bvModal.msgBoxConfirm('Deseja suspender a visualização da sala?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/salachat/' + id + '/suspenso').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    exportarSala (mocao) {
      window.location.href = process.env.ROOT_API1 + 'api/salachat/' + mocao + '/exportar'
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/salaChat/SalaChat.vue